module.exports = __webpack_public_path__ + "img/people@2x.234d6c29.png";